const l = {
  name: "XcodeBeta1",
  dimensions: { width: 39, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39 40" style="enable-background:new 0 0 39 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M18.4,26c0.1,0.1,0.1,0.3,0.2,0.4l0,0c0.8,1.4,2.4,2.1,4,1.6c1-0.3,1.8-1,2.2-2H26c2.8,0,5-2.2,5-5v-9.8
			l0.7-1.7c0.3,0.1,0.4,0.3,0.5,0.5l0,0l0,0c0.1,0.2,0.1,0.5,0,0.8l-0.4,0.9l1.8,0.8l0,0c1.5,0.6,3.3-0.1,3.9-1.6l1.1-2.8l0,0
			c0.6-1.5-0.1-3.3-1.6-3.9l0,0l-1.8-0.8l-0.4,0.9c-0.2,0.5-0.8,0.7-1.3,0.5l-0.1-0.1c0.1-1.2-0.6-2.4-1.9-2.9l-3.7-1.5l0,0
			c-1.3-0.5-2.6-0.5-3.8,0l0,0C23.3,0.7,22.6,1.3,22,2H12C9.2,2,7,4.2,7,7v14c0,2.8,2.2,5,5,5H18.4z M23.7,3.1
			c0.3-0.4,0.7-0.6,1.1-0.8c0.7-0.3,1.5-0.3,2.3,0l0,0l3.7,1.5c0.5,0.2,0.8,0.8,0.5,1.3L31,6l1.9,0.8c1.2,0.5,2.5,0.1,3.4-0.8
			L36.4,6c0.5,0.2,0.7,0.8,0.5,1.3l0,0l-1.1,2.8c-0.2,0.5-0.8,0.7-1.3,0.5l-0.2-0.1c0-0.4-0.1-0.9-0.2-1.3c-0.3-0.7-0.9-1.3-1.6-1.6
			l-1.8-0.8l-0.8,1.8l-2.6-1.1l-0.3-0.1C27,6.7,26.6,5.8,26,5C25.5,4.3,24.7,3.6,23.7,3.1z M25.3,9.1l-3.1,6.5l-2-3.1l3.2-4.9
			l-1.7-1.1L19,10.6l-2.7-4.1l-1.7,1.1l3.2,4.9L15.5,16H13v2h1.2l-1.6,2.5l1.7,1.1l2.3-3.5H21l-2.5,5.2c-0.1,0.2-0.2,0.5-0.3,0.8H12
			c-1.7,0-3-1.3-3-3V7c0-1.7,1.3-3,3-3h9l0,0l0.9,0.4c1.1,0.5,2,1.2,2.5,1.8C25,6.9,25,7.5,24.9,7.8l-0.4,0.9L25.3,9.1z M19,14.3
			l1.1,1.7h-2.2L19,14.3z M25.5,24l3.5-9.9V21c0,1.7-1.3,3-3,3H25.5z M20.3,24.1l6.9-14.3l1,0.4L23,25.2c-0.2,0.4-0.5,0.8-1,0.9l0,0
			c-0.6,0.2-1.3-0.1-1.7-0.7C20.1,25,20.1,24.5,20.3,24.1z"/>
		<path class="st0" d="M3,30H0v10h3c1.7,0,3-1.3,3-3c0-0.8-0.3-1.5-0.8-2C5.7,34.5,6,33.8,6,33C6,31.4,4.7,30,3,30z M2,38v-2h1
			c0.5,0,1,0.5,1,1s-0.5,1-1,1H2z M4,33c0,0.5-0.5,1-1,1H2v-2h1C3.5,32,4,32.5,4,33z"/>
		<path class="st0" d="M14,40H8V30h6v2h-4v2h4v2h-4v2h4V40z"/>
		<path class="st0" d="M22,30v2h-2v8h-2v-8h-2v-2H22z"/>
		<path class="st0" d="M26,40h-2V30h6v10h-2v-4h-2V40z M26,34h2v-2h-2V34z"/>
		<path class="st0" d="M36,38h2v2h-6v-2h2v-6h-2v-2h4V38z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as XcodeBeta1
};
